import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "w-1/3" }
const _hoisted_3 = { class: "w-1/3" }
const _hoisted_4 = { class: "w-1/3" }

import TextInput from "@/components/inputs/TextInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BirthdayPicker',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    label: {
        type: String,
        default: "",
    },
    readonly: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: "block text-xs font-semibold text-neutral-600"
    }, _toDisplayString(__props.label), 9, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(["flex space-x-2", __props.label ? 'mt-2' : ''])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TextInput, {
          type: "number",
          placeholder: "DD",
          name: "birthday-date",
          id: "birthday-date",
          readonly: __props.readonly
        }, null, 8, ["readonly"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TextInput, {
          type: "number",
          placeholder: "MM",
          name: "birthday-month",
          id: "birthday-month",
          readonly: __props.readonly
        }, null, 8, ["readonly"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TextInput, {
          type: "number",
          placeholder: "YYYY",
          name: "birthday-year",
          id: "birthday-year",
          readonly: __props.readonly
        }, null, 8, ["readonly"])
      ])
    ], 2)
  ]))
}
}

})